import React from 'react';
import { ArrowLeft, ShieldCheck } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const TermsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#0f172a] text-slate-300 p-6 md:p-12 font-sans selection:bg-blue-500/30">
      <div className="max-w-4xl mx-auto">
        <button
          onClick={() => navigate('/')}
          className="flex items-center gap-2 text-blue-400 hover:text-blue-300 mb-8 font-bold transition-colors"
        >
          <ArrowLeft size={18} /> Back to Home
        </button>

        <div className="bg-[#1e293b] border border-slate-700 rounded-3xl p-8 md:p-12 shadow-2xl">
          <div className="flex items-center gap-4 mb-8 border-b border-slate-700 pb-6">
            <div className="p-3 bg-blue-600/20 rounded-xl text-blue-400">
              <ShieldCheck size={32} />
            </div>
            <h1 className="text-3xl md:text-4xl font-black text-white">Terms of Use</h1>
          </div>

          <div className="space-y-8 text-sm leading-relaxed">
            <section>
              <h3 className="text-lg font-bold text-white mb-3">1. Acceptance of Terms</h3>
              <p>
                By accessing and using TradingBotPro ("the Service"), you accept and agree to be bound by the terms and provision of this agreement. In addition, when using these particular services, you shall be subject to any posted guidelines or rules applicable to such services.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-bold text-white mb-3">2. Description of Service</h3>
              <p>
                TradingBotPro provides an automated cryptocurrency trading interface connecting to third-party exchanges via API. We do not hold custody of your funds. You retain full control over your exchange accounts and funds at all times.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-bold text-white mb-3">3. Risk Disclosure</h3>
              <div className="bg-red-900/20 border border-red-500/30 p-4 rounded-xl text-red-200">
                <p className="font-bold mb-2">⚠️ Important Warning:</p>
                <p>
                  Cryptocurrency trading involves a substantial risk of loss and is not suitable for every investor. The valuation of cryptocurrencies and related products may fluctuate. Such changes may result in the loss of your invested capital. You should not invest money that you cannot afford to lose.
                </p>
              </div>
            </section>

            <section>
              <h3 className="text-lg font-bold text-white mb-3">4. Limitation of Liability</h3>
              <p>
                TradingBotPro is provided on an "AS IS" and "AS AVAILABLE" basis. We do not guarantee profits or specific results. We shall not be liable for any direct, indirect, incidental, or consequential damages resulting from the use or inability to use the service, including but not limited to damages for loss of profits, data, or other intangible losses.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-bold text-white mb-3">5. User Conduct</h3>
              <p>
                You agree not to use the Service for any illegal or unauthorized purpose. You are solely responsible for your conduct and any data, text, information, or other content that you submit, post, or display on or via the Service.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-bold text-white mb-3">6. Account Responsibility</h3>
              <p>
                You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You agree to notify us immediately of any unauthorized use.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-bold text-white mb-3">7. Termination</h3>
              <p>
                We may suspend or terminate your access to the Service at our sole discretion, without prior notice, for conduct that violates these Terms or is harmful to other users or our system.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-bold text-white mb-3">8. Privacy and Data</h3>
              <p>
                Use of the Service is also governed by our Privacy Policy. By using the Service, you consent to the collection, use, and sharing of your data as described therein.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-bold text-white mb-3">9. Changes to Terms</h3>
              <p>
                We reserve the right to modify or update these Terms at any time. Changes will be posted on this page with a revised "Last updated" date. Continued use of the Service constitutes acceptance of the updated Terms.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-bold text-white mb-3">10. Governing Law</h3>
              <p>
                These Terms shall be governed by and construed in accordance with the laws of the jurisdiction in which TradingBotPro operates, without regard to conflict of law principles.
              </p>
            </section>

            <div className="pt-8 border-t border-slate-700 text-xs text-slate-500">
              Last updated: February 8, 2026
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
